import { Table } from "antd";
import { usersColumns } from "./users.columns";

export default function UsersTable({ users, pagination, onPageChange, loading, handleActionClick }) {
  const dataSource = (users ?? []).filter(Boolean);

  return (
    <div className="users-table-wrapper">
      <Table
        columns={usersColumns(handleActionClick)}
        dataSource={dataSource}
        loading={loading}
        rowKey={(record) => record.id}
        scroll={{ x: 1500 }}
        pagination={{
          current: pagination.page,
          pageSize: pagination.limit,
          total: pagination.total,
          showSizeChanger: false,
          size: "small",
          onChange: onPageChange,
        }}
        className="users-table"
      />
    </div>
  );
}